import { styled } from '@mui/material'
import { useEffect, useState } from 'react'
import DateRangePickerLegionExpose from './DateRangePickerLegionExpose'
import { SmallRoundToggleButton } from '../common/CommonStyled'
import { useAdAchiveStore } from 'src/stores/AdAchiveStore'
import Team_AnalysisTable from './Team_AnalysisTable'
import { LoadTeamAnalysis } from './useLoadTeamAnalysis'

const TapWrapper = styled('div')(({theme})=>({
  display:'flex',
  flexDirection:'column',

  position:'relative',
  height:'calc(100vh - 202px)',
  padding:'20px',
}))

const TapContainer = styled('div')(({theme})=>({
  display: 'flex',
  justifyContent:'space-between',
}))

const ToogleWrapper = styled('div')(({theme})=>({
    display:'flex',
    justifyContent:'flex-start',
    alignItems:'center',
    gap:'10px',
    marginTop:'20.5px',
    marginBottom:'10px'
}))

const Team_Analysis = () => {
    const today = new Date();
    const prevMonth = new Date(today); // 오늘 날짜 복사
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    const [periodOption,setPeriodOption] = useState<string | number>('1개월')
    const data = useAdAchiveStore((state)=>state.teamAnalysisData)
    const [start_date,setStart_date] = useState<string| null>(prevMonth.toISOString().slice(0, 10))
    const [end_date,setEnd_date] = useState<string| null>(today.toISOString().slice(0, 10))
    const setField = useAdAchiveStore((state)=>state.setField)

    const fetchData = async () => {
    const result = await LoadTeamAnalysis(start_date,end_date);
    setField('teamAnalysisData',result)
    };

    useEffect(()=>{
    const startDate = new Date(today); // today 복사
    if (periodOption === ''){
        return
    }
    if (periodOption === '1개월') {
        startDate.setMonth(today.getMonth() - 1);
    } else if (periodOption === '3개월') {
        startDate.setMonth(today.getMonth() - 3);
    } else if (periodOption === '6개월') {
        startDate.setMonth(today.getMonth() - 6);
    } else if (periodOption === '1년') {
        startDate.setFullYear(today.getFullYear() - 1);
    }
    setStart_date(startDate.toISOString().slice(0, 10))
    setEnd_date(today.toISOString().slice(0, 10))
    },[periodOption])

    useEffect(()=>{
        fetchData()
    },[start_date,end_date])
    return (
        <TapWrapper>
            <TapContainer>
                <DateRangePickerLegionExpose start_date={start_date} end_date={end_date} setStart_date={setStart_date} setEnd_date={setEnd_date} setPeriodOption={setPeriodOption}/>
            </TapContainer>
            <ToogleWrapper>
                <SmallRoundToggleButton $isSelected={periodOption==='1개월'} onClick={()=>setPeriodOption('1개월')}>1개월</SmallRoundToggleButton>
                <SmallRoundToggleButton $isSelected={periodOption==='3개월'} onClick={()=>setPeriodOption('3개월')}>3개월</SmallRoundToggleButton>
                <SmallRoundToggleButton $isSelected={periodOption==='6개월'} onClick={()=>setPeriodOption('6개월')}>6개월</SmallRoundToggleButton>
                <SmallRoundToggleButton $isSelected={periodOption==='1년'} onClick={()=>setPeriodOption('1년')}>1년</SmallRoundToggleButton>
            </ToogleWrapper>
            <Team_AnalysisTable propsData={data}/>
        </TapWrapper>
    )
}

export default Team_Analysis